import { Vue } from 'vue-property-decorator'
import { PackageAPI, Package, PackageRef } from '../../api/package'
import JSZip from 'jszip'

const state = {
  current: null,
  currentZip: null,
  fileContents: {}
}

const getters = {}

const actions = {
  getPackage ({ commit }: any, ref: PackageRef) {
    PackageAPI.get(ref, pkg => {
      commit('setCurrent', pkg)

      const zip = new JSZip()
      zip.loadAsync(pkg.spec.source.literal, { base64: true }).then(
        z => commit('setCurrentZip', z)
      )
    })
  },
  fileContents ({ state, commit }: any, path: string) {
    if (state.currentZip) {
      const file = state.currentZip.files[path]

      if (file) {
        file.async('string').then(
          (contents: string) => commit('setFileContents', { file: path, content: contents })
        )
      }
    }
  }
}

const mutations = {
  setCurrent (state: any, pkg: Package) {
    state.current = pkg
    state.fileContents = {}
  },
  setCurrentZip (state: any, zip: JSZip) {
    state.currentZip = zip
  },
  setFileContents (state: any, data: any) {
    Vue.set(state.fileContents, data.file, data.content)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
